import React from "react";
import HoverIconButton from "components/HoverIconButton";
import { COLORS } from "utils/styles";

const DragNotice = ({ isDraggingOver, draggingFromThisWith }) => {
  const isSource = Boolean(draggingFromThisWith);
  const copy = isSource
    ? "Drop product on the list above to add to pricing table."
    : "Drop product here to remove from table.";

  return (
    <div
      style={{ backgroundColor: COLORS.whitesmoke }}
      className="absolute left-0 right-0 bottom-0 top-0 flex flex-row items-center pa2 bh--inset"
    >
      <div className="flex flex-row items-center justify-center">
        <HoverIconButton type="dragDrop" size={22} />
        <div className="f6 lh-copy">{copy}</div>
      </div>
    </div>
  );
};

export default DragNotice;
